/**
 * 开户粗包预热（动态 import，避免 store↔info 静态环）。
 * 线上壳已与路由同包；此处仅预热预约 offline。
 */

export function runWhenIdle(fn: () => void, timeout = 2000) {
  const ric = (
    window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    }
  ).requestIdleCallback;
  if (typeof ric === 'function') {
    ric(() => fn(), { timeout });
  } else {
    setTimeout(fn, 300);
  }
}

/** @deprecated 保留签名 */
export function preloadStep(_step: number, _mainland: boolean): Promise<unknown> {
  return Promise.resolve();
}

/** @deprecated */
export function preloadNeighborSteps(_current: number, _mainland: boolean) {}

/** 按 step 粗估相位预热（线上同包无需再拉；预约另处理） */
export function preloadPhaseForStep(_step: number) {}

export function preloadNearInfoSteps() {}

export function preloadDeepLinkShell(_step: number) {}

export function preloadEditRefusedSteps() {}
